import { COOKIE_DIALOG_LOCALSTORAGE, ICookieDialogLocalStorage } from '../types';

export const setCookieDialogLocalStorage = (
    cookieDialogLocalStorage: ICookieDialogLocalStorage
) => {
    localStorage.setItem(COOKIE_DIALOG_LOCALSTORAGE, JSON.stringify(cookieDialogLocalStorage));
}
